module.exports = __webpack_public_path__ + "static/media/logo_updated.5644bfb3.svg";